import {
  AssociatedContact,
  IAssociatedContact,
} from '@app/models/AssociatedContact'
import { Record } from 'immutable'

export interface IContextReminder {
  readonly author: IAssociatedContact
  readonly id: string
  readonly isComplete: boolean
  readonly sourceId: string
  readonly text: string
}

const ContextReminderRecord = Record({
  author: undefined,
  id: '',
  isComplete: false,
  sourceId: '',
  text: '',
})

export class ContextReminder extends ContextReminderRecord
  implements IContextReminder {
  public static fromJS(initialState?: Partial<IContextReminder>) {
    if (!initialState) {
      return new ContextReminder()
    }

    const { author, ...rest } = initialState

    return new ContextReminder({
      author: author ? AssociatedContact.fromJS(author) : undefined,
      ...rest,
    })
  }

  public readonly author: IAssociatedContact
  public readonly id: string
  public readonly isComplete: boolean
  public readonly sourceId: string
  public readonly text: string

  constructor(initialState?: Partial<ContextReminder>) {
    initialState ? super(initialState) : super()
  }
}
